import type { HonorDepartmentsResponse } from "./types/honor-careers";

import { marketingApiGet } from "./marketing-api-get";

type GetHonorJobDepartmentsOptions = {
  throwOnError?: boolean;
};

const HONOR_JOB_DEPARTMENTS_PATH = "/api/v1/honor/jobs/departments";

async function getHonorJobDepartments(
  options: GetHonorJobDepartmentsOptions = {},
): Promise<HonorDepartmentsResponse> {
  return marketingApiGet<HonorDepartmentsResponse>({
    emptyValue: {},
    logMessage: "Failed to fetch Honor job departments from hi-marketing-api",
    logTags: { component: "getHonorJobDepartments" },
    mapResponse: (response) =>
      response === null ? {} : (response as HonorDepartmentsResponse),
    path: HONOR_JOB_DEPARTMENTS_PATH,
    throwOnError: options.throwOnError,
  });
}

export { getHonorJobDepartments };
